import { AccEntryAddProvider, AccEntryOperProvider, AccEntrySearchProvider, AccEntryViewProvider } from '.'
import { Result, failure, success } from '../shared'
import {
  AccEntryAddTypes,
  AccEntryCommentsTypes,
  AccEntryFailure,
  AccEntryOperTypes,
  AccEntryViewTypes,
  AccEntryXlsxImportTypes,
} from './models/accEntry.types'
import { AccEntryCommentsProvider } from './providers/comments.provider'
import { AccEntryXlsxProvider } from './providers/xlsx.provider'

export class AccEntryService {
  constructor(
    private readonly searchProvider: AccEntrySearchProvider,
    private readonly viewProvider: AccEntryViewProvider,
    private readonly addProvider: AccEntryAddProvider,
    private readonly operProvider: AccEntryOperProvider,
    private readonly commentProvider: AccEntryCommentsProvider,
    private readonly xlsxProvider: AccEntryXlsxProvider,
  ) {}

  public async xlsxFile(
    action: AccEntryXlsxImportTypes,
    params: Record<string, any>,
  ): Promise<Result<any, AccEntryFailure>> {
    try {
      const { data } = await this.xlsxProvider.importFile(action, params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }

  public async xlsx(params: Record<string, any>): Promise<Result<any, AccEntryFailure>> {
    try {
      const { data } = await this.xlsxProvider.importXlsx(params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }

  public async comment(
    action: AccEntryCommentsTypes,
    params: Record<string, any>,
  ): Promise<Result<any, AccEntryFailure>> {
    try {
      const { data } = await this.commentProvider.comment(action, params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }

  public async search(params: Record<string, any>): Promise<Result<any, AccEntryFailure>> {
    try {
      const { data } = await this.searchProvider.search(params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }

  public async oper(action: AccEntryOperTypes, params: Record<string, any>): Promise<Result<any, AccEntryFailure>> {
    try {
      const { data } = await this.operProvider.oper(action, params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }

  public async add(action: AccEntryAddTypes, params: Record<string, any>): Promise<Result<any, AccEntryFailure>> {
    try {
      const { data } = await this.addProvider.add(action, params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }

  public async addOper(action: AccEntryAddTypes, params: Record<string, any>): Promise<Result<any, AccEntryFailure>> {
    try {
      const { data } = await this.addProvider.operAdd(action, params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
        FailedFields: error.FailedFields,
      })
    }
  }

  public async view(
    action: AccEntryViewTypes | null,
    params: Record<string, any>,
  ): Promise<Result<any, AccEntryFailure>> {
    try {
      const { data } = await this.viewProvider.view(action, params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }
}
